import { createAccountStorageFlag } from 'src/modules/brand/utils/account-storage-flag'

const dismissedFlag = createAccountStorageFlag('smsr-kalama-teaser-dismissed')
const seenRecordedFlag = createAccountStorageFlag('smsr-kalama-teaser-seen-recorded')

export function isKalamaTeaserDismissed(accountId: string): boolean {
  return dismissedFlag.read(accountId)
}

export function dismissKalamaTeaser(accountId: string): void {
  dismissedFlag.write(accountId)
}

export function isKalamaTeaserImpressionRecorded(accountId: string): boolean {
  return seenRecordedFlag.read(accountId)
}

export function markKalamaTeaserImpressionRecorded(accountId: string): void {
  seenRecordedFlag.write(accountId)
}
